import { render, staticRenderFns } from "./SSOKeyCloakLogin.vue?vue&type=template&id=c39d69a0"
import script from "./SSOKeyCloakLogin.vue?vue&type=script&lang=js"
export * from "./SSOKeyCloakLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports